module.exports = __webpack_public_path__ + "8c33be54b30cbe90ad64e9e6df2d3a95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-17.png
// module id = 3124
// module chunks = 0